module.exports = {
	"pathContext": {
		"name": "stockholm",
		"photos": [
			"stockholm/DSC_9661.jpg",
			"stockholm/DSC_9665.jpg",
			"stockholm/DSC_9674.jpg",
			"stockholm/DSC_9713.jpg",
			"stockholm/DSC_9747.jpg",
			"stockholm/DSC_9762.jpg",
			"stockholm/DSC_9774.jpg",
			"stockholm/DSC_9777.jpg",
			"stockholm/DSC_9788.jpg",
			"stockholm/DSC_9790.jpg",
			"stockholm/DSC_9802.jpg",
			"stockholm/DSC_9807.jpg",
			"stockholm/DSC_9814.jpg",
			"stockholm/DSC_9818.jpg",
			"stockholm/DSC_9820.jpg",
			"stockholm/DSC_9835.jpg",
			"stockholm/DSC_9841.jpg",
			"stockholm/DSC_9852.jpg",
			"stockholm/DSC_9854.jpg",
			"stockholm/DSC_9860.jpg",
			"stockholm/DSC_9893.jpg"
		],
		"next": null,
		"previous": {
			"name": "copenhagen"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/photos-stockholm.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/photos-stockholm.json
// module chunks = 6864713465792373000